// Port of api/fuel/app/classes/controller/api/monty/groups/users.php
import F from 'offline/filter/constants'
import UsersFilter from 'offline/filter/users'
import { runFilterEndpoint } from 'offline/api/monty'

export default function(params) {
	if (!params.slug && params.name) params = Object.assign({}, params, { slug: params.name })
	return runFilterEndpoint(UsersFilter, params, F.OWNER_GROUP)
}
